'use client'

import { type FC, type PropsWithChildren, useMemo } from 'react'
import { useIntl } from 'react-intl'

import { LocaleContext, type LocaleContextValue } from 'base-ui'

export const I18nBaseUiLocaleContext: FC<PropsWithChildren> = ({
  children,
}) => {
  const { formatMessage } = useIntl()

  const value: LocaleContextValue = useMemo(
    () => ({
      circularProgress: {
        loading: formatMessage({ id: 'screenReader.loading' }),
      },
      dialog: {
        close: formatMessage({ id: 'general.link.label.close' }),
      },
      select: {
        close: formatMessage({ id: 'general.link.label.close' }),
      },
    }),
    [formatMessage],
  )

  return <LocaleContext value={value}>{children}</LocaleContext>
}
